import { Pipe, PipeTransform } from '@angular/core';
import { USER_APPROVAL_STATUS } from '../enums';
import { EnumConverter } from '../classes';

@Pipe({
  name: 'userApprovalStatus'
})
export class UserApprovalStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = USER_APPROVAL_STATUS;
}
